import { Box, InlineBanner } from '@cad-arc';
import { useEsriEmbeddedBaseMap } from '../esri/base-maps/use-esri-embedded-base-map';
import { getPolygonCenter } from '../esri/helpers/polygons';
import { useSingleGraphicDisplayLayer } from '../esri/hooks/use-single-graphic-display-layer';
import { GeoPoint } from '../location/types';
import { errorOccurredWhile } from '../common/helpers/error-occurred-while';
import { observer } from 'mobx-react-lite';

export const LocationPolygonSearchMap = observer(function LocationPolygonSearchMap({ points }: { points: GeoPoint[] }) {
    const center = getPolygonCenter(points);
    const { mapView, mapComponent, isMapLoadingFailed } = useEsriEmbeddedBaseMap({
        center,
        surface: 'location-polygon-search',
    });
    useSingleGraphicDisplayLayer({ mapView, center, points });

    return (
        <Box w="250px" h="250px">
            {isMapLoadingFailed ? (
                <InlineBanner status="error" description={errorOccurredWhile('loading the map')} />
            ) : (
                mapComponent
            )}
        </Box>
    );
});
